import isEqual from 'lodash/isEqual';

import * as actions from './actions';
import services from 'core/services';

export function getNotification(token) {
  return (dispatch, getState, ecommerce) => {
    return new Promise((resolve, reject) => {
      ecommerce.Auth.updatePushNotificationData(token)
        .then(r => {
          // console.log('updatePushNotificationData:', token)
          resolve(token);

          services.storage.set('fcm-token', token);

          dispatch(actions.updatePushNotificationDataSuccess(token));

        })
        .catch(err => {
          console.log('updatePushNotificationData error:', err)
          services.storage.remove('fcm-token');
          reject(err)
        });
    });
  }
}

export function changeVisibleSearchView(value) {
  return dispatch => {
    dispatch(actions.changeVisibleSearchView(value))
  }
}

export function changeVisibleCartView(value) {
  return dispatch => {
    dispatch(actions.changeVisibleCartView(value))
  }
}

export function changeVisibleMainToolbar(value) {
  return dispatch => {
    dispatch(actions.changeVisibleMainToolbar(value))
  }
}

export function availability(value) {
  return dispatch => {
    dispatch(actions.changeAvailability(value))
  }
}

/**
 * hide splash
 */
export function hideSplash() {
  return dispatch => {
    dispatch(actions.changeSplash(false))
  }
}

export function changeActiveTab(value = 1) {
  return dispatch => {
    dispatch(actions.changeTab(value))
  }
}

export function profile(params) {
  return (dispatch, getState, ecommerce) => {
    // console.log('profile customer_token:', services.storage.get('customer_token'))

    if (!services.storage.get('customer_token'))
      return dispatch(actions.getProfileError());

    return new Promise((resolve, reject) => {
      ecommerce.User.profile(params)
        .then(r => {
          const customer = r.data.customer;

          dispatch(actions.getProfileSuccess(customer));

          resolve(customer);
        })
        .catch(e => {
          // console.log('updatePushNotificationData error:', err)

          services.storage.remove('customer_token');

          dispatch(actions.getProfileError());
          reject(e);
        })
    });
  };
};

export function Login(username = '', password = '', remember = true) {
  return (dispatch, getState, ecommerce) => {
    return new Promise((resolve, reject) => {
      ecommerce.Auth.login(username, password, remember)
        .then(res => {
          const { user, payload } = res.data.token

          services.storage.set('customer_token', payload)

          dispatch(actions.authenticated(user, payload))

          resolve(user, payload)
        })
        .catch(e => {
          dispatch(actions.unauthorized())

          services.storage.remove('customer_token')

          reject(e)
        })
    });
  };
};

export function register(data, params) {
  return (dispatch, getState, ecommerce) => {
    return new Promise((resolve, reject) => {
      ecommerce.Auth.register(data, params)
        .then(res => {
          dispatch(actions.registerSuccess())

          resolve()
        })
        .catch(e => {
          reject(e)
        })
    });
  };
};

export function logout() {
  return (dispatch, getState, ecommerce) => {
    return new Promise((resolve, reject) => {
      ecommerce.Auth.logout()
        .then(res => {
          services.storage.remove('customer_token')

          dispatch(actions.unauthorized())

          resolve(res)
        })
        .catch(e => {
          reject(e)
        })
    });
  };
};

export function verification(data, params) {
  return (dispatch, getState, ecommerce) => {
    return new Promise((resolve, reject) => {
      ecommerce.Auth.verification(data, params)
        .then(res => {
          const customer = res.data.customer;

          const model = customer ? customer : { mobile: data.mobile }

          dispatch(actions.verificationSuccess(model))

          resolve(customer)
        })
        .catch(e => {
          reject(e)
        })
    });
  };
};

export function registerFinalize(data, params) {
  return (dispatch, getState, ecommerce) => {
    return new Promise((resolve, reject) => {
      ecommerce.Auth.registerFinalize(data, params)
        .then(res => {
          dispatch(actions.registerFinalizeSuccess())

          resolve(res)
        })
        .catch(e => {
          reject(e)
        })
    });
  };
};

export function editProfile(data, params) {
  return (dispatch, getState, ecommerce) => {
    return new Promise((resolve, reject) => {
      ecommerce.Auth.editProfile(data, params)
        .then(res => {
          const customer = res.data.customer;

          dispatch(actions.editProfileSuccess(customer))

          resolve(res)
        })
        .catch(e => {
          reject(e)
        })
    });
  };
};

export function getAddresses(params) {
  return (dispatch, getState, ecommerce) => {
    return new Promise((resolve, reject) => {
      ecommerce.Address.getAddresses(params)
        .then(res => {
          const addresses = res.data.addresses;

          dispatch(actions.getAddressesSuccess(addresses))

          resolve(addresses)
        })
        .catch(e => {
          reject(e)
        })
    });
  };
};

export function addAddress(data, params) {
  return (dispatch, getState, ecommerce) => {
    return new Promise((resolve, reject) => {
      ecommerce.Address.addAddress(data, params)
        .then(res => {
          const addresses = res.data.addresses;

          dispatch(actions.addAddressSuccess(addresses))

          resolve(addresses)
        })
        .catch(e => {
          reject(e)
        })
    });
  };
};

export function editAddress(id, data, params) {
  return (dispatch, getState, ecommerce) => {
    return new Promise((resolve, reject) => {
      ecommerce.Address.editAddress(id, data, params)
        .then(res => {
          const addresses = res.data.addresses;

          dispatch(actions.editAddressSuccess(addresses))

          resolve(addresses)
        })
        .catch(e => {
          reject(e)
        })
    });
  };
};

export function deleteAddress(id, params) {
  return (dispatch, getState, ecommerce) => {
    return new Promise((resolve, reject) => {
      ecommerce.Address.deleteAddress(id, params)
        .then(res => {
          dispatch(actions.deleteAddressSuccess(id))

          resolve(res)
        })
        .catch(e => {
          reject(e)
        })
    });
  };
};

export function deviceToken(data, params) {
  return (dispatch, getState, ecommerce) => {
    return new Promise((resolve, reject) => {
      ecommerce.Auth.deviceToken(data, params)
        .then(res => {
          const token = res.data.token;

          services.storage.set('device_token', token)

          dispatch(actions.getDeviceTokenSuccess(token))

          resolve(token)
        })
        .catch(e => {
          console.log('deviceToken:', e)
          dispatch(actions.getDeviceTokenUnSuccess())

          services.storage.remove('device_token')

          reject(e)
        })
    });
  };
};

export function disableApp() {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(actions.disableApp())

      resolve(true)
    })
  }
}

export function enableApp() {
  return dispatch => {
    dispatch(actions.enableApp())
  }
}

export function healthinfo(params) {
  return (dispatch, getState, ecommerce) => {
    return new Promise((resolve, reject) => {
      ecommerce.App.healthinfo(params)
        .then(res => {
          const server = res.data.server;

          dispatch(actions.healthinfoSuccess(server))

          resolve(server)
        })
        .catch(e => {
          dispatch(actions.healthinfoError())

          reject(e)
        })
    });
  };
};

export function getConfig() {
  return (dispatch, getState, ecommerce) => {
    return new Promise((resolve, reject) => {
      ecommerce.App.config()
        .then(res => {
          const env = res.data.config;

          dispatch(actions.configSuccess(env))

          resolve(env)
        })
        .catch(e => {
          reject(e)
        })
    });
  };
};

export function registrarion() {
  return (dispatch, getState, ecommerce) => {
    return new Promise((resolve, reject) => {
      const params = {
        errorHandler: false
      }

      getRegistrationInfo()
        .then(info => {
          var prevDeviceInfo = services.storage.get('device_info');

          if (prevDeviceInfo && isEqual(prevDeviceInfo, info)) {
            resolve(info);

            return;
          }
          // console.log("registration", info)
          ecommerce.App.deviceinfo(info, params)
            .then(res => {
              const client = res.data.client;

              services.storage.set('device_info', client.device)
              services.storage.set('appVersion', client.device.appVersion)
              services.storage.set('version', client.device.version)
              services.storage.set('platform', client.device.platform)
              services.storage.set('serial', client.device.serial)
              services.storage.set('model', client.device.model)
              services.storage.set('manufacturer', client.device.manufacturer)
              // console.log(client.device)
              dispatch(actions.getClientInfoSuccess(client))

              resolve(client)
            })
            .catch(e => {
              reject(e)
            })
        })
    });
  };
}

export function getRegistrationInfo() {
  let deviceInfo = {
    platform: device.platform,
    model: device.model,
    version: device.version,
    manufacturer: device.manufacturer,
    serial: device.serial
  };

  return new Promise((resolve, reject) => {
    cordova.getAppVersion.getVersionNumber().then(function (version) {
      const _version = versionNumberToVersionCode(version);

      resolve(Object.assign({}, {
        appVersion: _version
      }, deviceInfo));
    });
  });
}

export function versionNumberToVersionCode(versionNumber = '1.11.5') {
  const splitted_version = versionNumber.split('.');

  if (splitted_version.length < 3) return 0;

  const MAJOR = splitted_version[0];
  const MINOR = splitted_version[1];
  const PATCH = splitted_version[2];

  return (MAJOR * 10000) + (MINOR * 100) + (PATCH * 1)
}

export function versionCodeToVersionNumber(versionCode = 11111) {
  if (!versionCode) return null;

  const patchAppVersion = versionCode % 100;
  const minorAppVersion = (versionCode % 10000 - patchAppVersion) / 100;
  const majorAppVersion = (versionCode - (minorAppVersion * 100) - patchAppVersion) / 10000;

  return majorAppVersion + "." + minorAppVersion + "." + patchAppVersion;
}

export function openLinkInBrowser(url) {
  // Handle click events for all external URLs
  if (device.platform.toUpperCase() === 'ANDROID') {
    navigator.app.loadUrl(url, { openExternal: true });
  } else if (device.platform.toUpperCase() === 'IOS') {
    window.open(url, '_blank');
    // window.open(url, '_system');
  } else {
    window.open(url, '_blank');
  }
}